<template>
  <v-flex xs12 px-3>
    <v-card class="e-pregunta mb-5">
      <v-card-text class="p-normal pa-5 fill-height align-center d-flex text-xs-center justify-center">
        {{ pregunta }}
      </v-card-text>
      <v-card-actions class="text-xs-center justify-space-around">
        <v-btn fab large color="success" style="width: 72px !important" @click="validate('true')">
          <v-icon>check</v-icon>
        </v-btn>
        <v-btn fab large color="error" style="width: 72px !important" @click="validate('false')">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  name: 'CardPregunta',
  props: {
    pregunta: {
      type: String,
      default: ''
    },
    route: {
      type: String,
      default: ''
    },
    respuesta: {
      type: String,
      default: ''
    }
  },
  methods: {
    validate(userAnswer){
      //this.$router.push(this.route)
    }
  }
}
</script>